export const CENTER = '/center'
